/**
 * Created by tomers on 10/14/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var ApiResources = require("assets/data/apiResources.json");
    var LEResourceResolver = require("leResourceResolver");
    var RevisionedModel = require("models/RevisionedModel");

    var KEYS = {
        ID: "id",
        NAME: "name",
        REVISION: "revision",
        FILE_DATA: "fileData",
        FILE_TYPE: "fileType"
    };

    var FILE_TYPE = {
        CERTIFICATE: 1,
        KEY: 0
    };

    var VALID_FILE_EXTENSION = "pem";

    var AppKeyFileModel = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        AppKeyFileModel = RevisionedModel.extend({
            apiResource: ApiResources.Applications.FileUpload,
            name: "AppKeyFileModel",
            resource: function() {
                var isNew = this.isNew();
                var params = {
                    applicationId: this.appId,
                    fileType: this.getFileType(),
                    fileId: (!isNew) ? this.id : "",
                    revisionParam: (!isNew) ? "&revision="+this.getRevision() : ""
                };
                return LEResourceResolver.extendResourceWithOptions.call(this, this.apiResource, params);
            },
            defaults: {
                id: null,
                name: "",
                fileData: "",
                fileType: "",
                revision: ""
            },

            initialize: function(attrs, options) {
                this.appId = options.appId;
            },

            getRevision: function() {
                return this.get(KEYS.REVISION);
            },

            getFileType: function() {
                return this.get(KEYS.FILE_TYPE);
            },

            isCertificate: function() {
                return (this.getFileType() === FILE_TYPE.CERTIFICATE);
            },

            isKey: function() {
                return (this.getFileType() === FILE_TYPE.KEY);
            }


        });
    }

    LE.module("LEManager", moduleDefinition);

    AppKeyFileModel.VALID_FILE_EXTENSION = VALID_FILE_EXTENSION;

    return AppKeyFileModel;

});
